export default __webpack_public_path__ + "104fcf4005c2f8b89766a43c489c6c3f.png";